import React from 'react';
import { Localize } from 'components/service';
import GraphicPacking from 'components/graphic-packing';
import { useBreadCrumbs } from "components/use-hooks";

const basePath = GraphicPacking.Const.basePath;

const GraphicPackingOverviewSubPage = ({ graphicPacking, history, loading, isCreate }) => {


    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Graphic_Commissioning" }).props.children,
            path: `${basePath}`
        },
        {
            label: (graphicPacking && ` ${graphicPacking?.title}`) || Localize({ children: "BREADCRUMBS.Label_Create" }).props.children,
            path: (graphicPacking && `${basePath}/${graphicPacking?.id}`) || `${basePath}/create`
        }
    ];


    useBreadCrumbs(breadcrumbs);

    return (
        <div className="row-grid col-lg-2">
            <div className="col-left">
                <GraphicPacking.Forms.Edit
                    graphicPacking={graphicPacking}
                    loading={loading}
                    isCreate={isCreate}
                    history={history}
                />
            </div>
            <div className="col-right">
            </div>
        </div>
    );
};

export default GraphicPackingOverviewSubPage;